import React, { useContext } from "react"
import { ChatWidget } from "@smaller-earth/postcard-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCampground, faHotel } from "@fortawesome/pro-regular-svg-icons"
import UserContext from "@context/UserContext"
import { usePageContext } from "@context/PageContext"
import { useAssistant } from "@context/AssistantContext"
import { getBrand } from "@helpers/siteHelpers"

// Mounted once near the root of the app (inside the user/page/assistant
// providers) so it persists across route changes. Pages still publish their
// own pageContext via PageContextSetter; this just keeps the in-memory chat
// session alive while the user navigates.
const AssistantPanel = () => {
  const { user, menu } = useContext(UserContext)
  const { pageContext } = usePageContext()
  const { isOpen, toggle } = useAssistant()

  const agentEnabled = menu?.agentEnabled && process.env.REACT_APP_AIOL_URL
  if (!agentEnabled) return null

  const { hostWord } = getBrand()
  const pageContextIcon = <FontAwesomeIcon icon={hostWord === "Resort" ? faHotel : faCampground} />

  return (
    <ChatWidget
      isOpen={isOpen}
      onClose={toggle}
      aiolBaseUrl={process.env.REACT_APP_AIOL_URL}
      postcardApiV1BaseUrl={process.env.REACT_APP_API_V1_BASE_URL}
      getAuthToken={() => user?.access_token}
      getApiKey={() => process.env.REACT_APP_API_KEY}
      pageContext={pageContext}
      pageContextIcon={pageContextIcon}
      debugMode={localStorage.getItem("aiol_debug") === "true"}
    />
  )
}

export default AssistantPanel
